export default __webpack_public_path__ + "static/media/support.98557bc5.svg";